import { Fragment, useEffect, useState } from "react";

import { StoreService } from "../cua-hang-xang-dau/StoreService";
import { TaxService } from "../thue-suat/TaxService";
import { DeviceService, DeviceService as Service } from "./DeviceService";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { ConfirmDialogService } from "../../../AppConfirmDialog";
import { ToastService } from "../../../AppToast";
import { RegisterInvoiceService } from "../../../service/invoice/RegisterInvoiceService";
import { useDataTable } from "../../../shared/hooks/DataTable";
import { useDialogCrup } from "../../../shared/hooks/DialogCrup";
import { useForm } from "../../../shared/hooks/Form";
import { useToolbar } from "../../../shared/hooks/Toolbar";
import { TenantSettingService } from "../../he-thong/tham-so-he-thong/TenantSettingService";
import { PetrolimexService } from "../hang-hoa-xang-dau/PetrolimexService";
import { useTranslation } from "../../../shared/language";

const groupByProductCode = (data, storeCode) => {
  const filtered = storeCode
    ? data.filter((x) => x.storeCode === storeCode)
    : [];

  const result = Object.values(
    filtered.reduce((acc, item) => {
      const key = item.productCode;

      if (!acc[key]) {
        acc[key] = {
          productCode: key,
          productName: item.productName,
          nozzles: item.code,
          newPrice: item.newPrice ?? null,
        };
      } else {
        acc[key].nozzles += `, ${item.code}`;
      }

      return acc;
    }, {})
  );

  return result;
};

// Giữ mã này cho cấu hình cũ chỉ có CompanyId và StationId để không đổi request hiện hữu.
const LEGACY_PECO_DEVICE_ID = "0123456789";

// Cấu hình mới chỉ mang DeviceId; nhánh cũ giữ nguyên định dạng tham số để các tenant chưa cập nhật vẫn chạy được.
const parsePecoConfigForStore = (settingValue: string, storeCode: string) => {
  const storePrefix = `${storeCode}_`;
  const matchedConfig = (settingValue ?? "")
    .split(",")
    .map((item) => item.trim())
    .find((item) => item.startsWith(storePrefix));

  if (!matchedConfig) {
    return null;
  }

  const configValues = matchedConfig
    .slice(storePrefix.length)
    .split("_")
    .map((item) => item.trim());

  if (configValues.length === 1 && configValues[0]) {
    return { deviceId: configValues[0], companyId: "", stationId: "" };
  }

  if (configValues.length === 2 && configValues.every(Boolean)) {
    return {
      companyId: configValues[0],
      stationId: configValues[1],
      deviceId: LEGACY_PECO_DEVICE_ID,
    };
  }

  if (configValues.length >= 3 && configValues[0] && configValues[1]) {
    return {
      companyId: configValues[0],
      stationId: configValues[1],
      deviceId: configValues.slice(2).join("_"),
    };
  }

  return null;
};

/** Hiển thị danh sách thiết bị và thao tác đổi giá tại tủ PECO. */
export const List = () => {
  const {t} = useTranslation();
  const header = t('menu.pump');
  const dataKey = "id";

  const [petrolimexs, setPetrolimexs] = useState([]);
  const [stores, setStores] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [serials, setRegisterInvoice] = useState(null);
  const [manyActions, setManyActions] = useState([]);
  const [visible, setVisible] = useState<boolean>(false);
  const [openDialogConfirm, setOpenDialogConfirm] = useState<boolean>(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [dataTable, setDataTable] = useState<any>([]);
  const [stationId, setStationId] = useState<string>("");
  const [companyId, setCompanyId] = useState<string>("");
  const [deviceId, setDeviceId] = useState<string>("");

  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000 }).then(
      ({ items }) => {
        const _serials = [];
        items.forEach((item) => {
          _serials.push({ value: item.id, label: item.symbolCode });
        });
        setRegisterInvoice(_serials);
      }
    );

    PetrolimexService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({ items }) => {
      const _petrolimexs = [];
      items.forEach((item) => {
        _petrolimexs.push({
          value: item.code,
          label: item.code + " - " + item.name,
        });
      });
      setPetrolimexs(_petrolimexs);
    });
    StoreService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({ items }) => {
      const _stores = [];
      items.forEach((item) => {
        _stores.push({
          value: item.code,
          label: item.code + " - " + item.storeName,
        });
      });
      setStores(_stores);
    });
    TaxService.getList({}).then(({ items }) => {
      const _taxs = [];
      items.forEach((item) => {
        _taxs.push({ value: item.id, label: item.name, ratio: item.ratio });
      });
      setTaxs(_taxs);
    });
  }, []);

  // useEffect(() => {
  //   if(visible){
  //     EntityService.getList({skipCount: 0, maxResultCount: 1000}).then(({items}) => {
  //       const _entities = [];
  //       items.forEach((item) => {
  //         _entities.push({value: item.id, label: item.name});
  //       });
  //       setEntities(_entities);
  //     });
  //   }
  //   console.log(entities)
  // }, [visible]);

  const handleChangePricePECO = () => {
    const value = getValueForm();

    if (!deviceId.trim()) {
      ToastService.error(t("validation.pecoDeviceIdMissing"));
      return;
    }

    const itemsToUpdate = dataTable.filter(
      (item) => item.newPrice !== null && item.newPrice !== undefined
    );

    const groupedProducts = Object.values(
      itemsToUpdate.reduce((acc, item) => {
        const key = item.productCode;

        if (!acc[key]) {
          acc[key] = {
            code: item.productCode,
            name: item.productName,
            nozzleIds: [item.code],
            newPrice: item.newPrice,
          };
        } else if (!acc[key].nozzleIds.includes(item.code)) {
          acc[key].nozzleIds.push(item.code);
        }
        return acc;
      }, {})
    );

    const data = {
      ...value,
      effectiveDT: new Date(value?.effectiveDT).toISOString(),
      expiryDT: new Date(value?.expiryDT).toISOString(),
      products: groupedProducts,
      deviceType: "MIV",
      deviceId,
      seqNumber: "001122334455",
      swVer: "1.2.3",
      checkSum: "20",
      companyId,
      stationId,
    };

    PetrolimexService.changePricePECO(data)
      .then((res) => {
        if (!res) {
          ToastService.error(t("validation.pecoPriceUpdateFailed"));
          return;
        }
        ToastService.success(res.message);
      })
      .catch(() => {
        ToastService.error(t("validation.pecoPriceUpdateFailed"));
      });

    handleCloseDialogChangePricePECO();
    setOpenDialogConfirm(false);
  };

  const handleCloseDialogChangePricePECO = () => {
    setVisible(false);
    setSelectedStore(null);
    setDataTable([]);
    setDeviceId("");
    setCompanyId("");
    setStationId("");
    setValueForm({});
  };

  const {
    render: renderDataTable,
    refreshLazyData,
    reloadLazyData,
    selectedItems,
    dataTableParams,
  } = useDataTable({
    header,
    dataKey,
    columns: [
      {
        field: "code",
        header: t('catalog.pumpNozzleCode'),
        width: 200,
        matchMode: "contains",
      },
      {
        field: "productCode",
        header: t('catalog.fuelCodeAtPump'),
        width: 220,
        matchMode: "contains",
        filterType: "dropdown",
        filterOptions: petrolimexs,
        dataType: "custom",
        customCell(rowData: any): any {
          return rowData.productName;
        },
      },
      {
        field: "invoiceSerial",
        header: t('catalog.integrationSymbol'),
        width: 200,
        matchMode: "contains",
      },
      {
        field: "storeCode",
        header: t('catalog.petrolStoreName'),
        minWidth: 260,
        matchMode: "contains",
        filterType: "dropdown",
        filterOptions: stores,
        dataType: "custom",
        customCell(rowData: any): any {
          return rowData.storeCode + " - " + rowData.storeName;
        },
      },
      {
        field: "series",
        header: t('catalog.pumpSeries'),
        width: 200,
        matchMode: "contains",
      },
      {
        field: "type",
        header: t('catalog.measuringColumnType'),
        width: 200,
        matchMode: "contains",
      },
      {
        field: "model",
        header: t('catalog.modelApproval'),
        width: 200,
        matchMode: "contains",
      },
      {
        field: "isMaintain",
        header: t('catalog.maintenance'),
        matchMode: "equals",
        filterType: "boolean",
        width: 160,
        dataType: "checkbox",
      },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    },
  });
  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    render: renderDialogCrup,
    create,
    update,
    clone,
    getValue,
    setValue,
    touched,
  } = useDialogCrup({
    header,
    dataKey,
    width: "60rem",
    fields: [
      {
        field: "code",
        header: t('catalog.pumpNozzleCode'),
        required: true,
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "productCode",
        header: t('catalog.fuelAtPump'),
        required: true,
        type: "Dropdown",
        DropdownProps: { options: petrolimexs, filter: true },
        className: "md:col-12",
      },
      {
        field: "storeCode",
        header: t('catalog.store'),
        required: true,
        type: "Dropdown",
        DropdownProps: { options: stores, filter: true },
        className: "md:col-12",
      },
      {
        field: "registerInvoiceId",
        header: t('catalog.integrationSymbol'),
        required: true,
        type: "Dropdown",
        DropdownProps: { options: serials, filter: true },
        className: "md:col-6",
      },
      {
        field: "series",
        header: t('catalog.pumpSeries'),
        required: false,
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "type",
        header: t('catalog.measuringColumnType'),
        required: false,
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "model",
        header: t('catalog.modelApproval'),
        required: false,
        InputTextProps: { maxLength: 50 },
        className: "md:col-6",
      },
      {
        field: "isMaintain",
        type: "Checkbox",
        header: t('catalog.maintenance'),
        className: "md:col-12",
      },
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData,
  });

  const { taxId, listPrice } = getValue();

  useEffect(() => {
    if (touched) {
      const _value = getValue();
      _value.price = 0;
      if (listPrice > 0) {
        _value.price = listPrice;
      }
      if (taxId) {
        const ratio = taxs.find((it) => it.value === taxId)?.ratio;
        if (listPrice > 0 && ratio > 0) {
          _value.price = formatNumber(listPrice / (1 + ratio / 100));
        }
      }
      setValue(_value);
    }
  }, [taxId, listPrice]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatNumber = (number) => {
    if (typeof number === "number") {
      if (!Number.isFinite(number) || Number.isNaN(number)) {
        number = 0;
      }
      if (`${number}`.length > 2 && `${number}`.split(".").length) {
        number = 1 * number.toPrecision(`${number}`.split(".")[0].length + 2);
      }
    }
    return number;
  };

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey,
    create,
    update: (item) => {
      Service.get(item[dataKey]).then((data) => {
        if (data.price > 0) {
          data.listPrice = data.price;
        }
        if (data.ratioTax > 0 && data.price > 0) {
          data.listPrice = Math.round(data.price * (1 + data.ratioTax / 100));
        }
        update(data);
      });
    },
    clone: (item) => {
      Service.get(item[dataKey]).then((data) => {
        clone(data);
      });
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [...manyActions],
    functionActions: [
      {
        label: t('catalog.pecoPriceChange'),
        icon: "pi pi-pencil",
        command: () => {
          setVisible(true);
        },
        className: "iam-toolbar-change-price-peco",
      },
    ],
  });

  const {
    render: renderForm,
    setValue: setValueForm,
    getValue: getValueForm,
  } = useForm({
    fields: [
      {
        field: "effectiveDT",
        header: t('catalog.effectiveTime'),
        required: true,
        type: "Calendar",
        className: "md:col-12",
        CalendarProps: {
          showIcon: true,
          showTime: true,
          showSeconds: true,
          hourFormat: "24",
          dateFormat: "dd/mm/yy",
        },
      },
      {
        field: "expiryDT",
        header: t('catalog.expiryTime'),
        required: true,
        type: "Calendar",
        className: "md:col-12",
        CalendarProps: {
          showIcon: true,
          showTime: true,
          showSeconds: true,
          hourFormat: "24",
          dateFormat: "dd/mm/yy",
        },
      },
      {
        field: "storeCode",
        header: t('catalog.chooseStore'),
        required: true,
        type: "Dropdown",
        DropdownProps: {
          options: stores,
          optionLabel: "label",
          optionValue: "value",
          placeholder: t('catalog.chooseStore'),
          required: true,
        },
        className: "md:col-12",
      },
      {
        field: "code",
        header: t('catalog.securityCode'),
        required: true,
        type: "Password",
        InputTextProps: { maxLength: 50 },
        className: "md:col-12",
      },
      {
        field: "data",
        type: "custom",
        body: selectedStore && (
          <DataTable
            value={groupByProductCode(dataTable, selectedStore)}
            stripedRows
            size="normal"
            dataKey="productCode"
          >
            <Column field="productName" header={t('catalog.fuel')} />
            <Column field="nozzles" header={t('catalog.pump')} />
            <Column
              field="newPrice"
              header={t('catalog.newPrice')}
              align="right"
              body={(rowData, options) => (
                <InputNumber
                  value={rowData.newPrice}
                  className="w-full"
                  inputClassName="text-right"
                  minFractionDigits={0}
                  maxFractionDigits={2}
                  mode="decimal"
                  onValueChange={(e) => {
                    const newValue = e.value;
                    const newData = dataTable.map((item) => {
                      if (item.productCode === rowData.productCode) {
                        return { ...item, newPrice: newValue };
                      }
                      return item;
                    });
                    setDataTable(newData);
                  }}
                />
              )}
            />
          </DataTable>
        ),
      },
      {
        field: "",
        type: "custom",
        body: (
          <div className="flex justify-content-center gap-2">
            <Button
              label={t('common.convert')}
              className="w-max"
              onClick={() => {
                const value = getValueForm();

                if (!value.storeCode) {
                  ToastService.error(t('validation.chooseStore'));
                  return;
                }

                if (!value.code) {
                  ToastService.error(t('validation.enterSecurityCode'));
                  return;
                }
                if (!deviceId.trim()) {
                  ToastService.error(t("validation.pecoDeviceIdMissing"));
                  return;
                }
                setOpenDialogConfirm(true);
              }}
            />
            <Button
              type="button"
              label={t('common.cancel')}
              className="w-max p-button-secondary"
              onClick={handleCloseDialogChangePricePECO}
            />
          </div>
        ),
      },
    ],
  });

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({ id }) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid(t('validation.selectDevice'));
      return;
    }
  };

  useEffect(() => {
    if (visible) {
      const now = new Date();
      const effective = new Date(now.setHours(15, 0, 0, 0));
      const expiration = new Date(now.setDate(now.getDate() + 6));
      setValueForm({
        effectiveDT: effective,
        expiryDT: expiration,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    const formValue = getValueForm();
    // Bỏ qua phản hồi của cửa hàng trước nếu người dùng đã đổi lựa chọn trong lúc request đang chạy.
    let isCurrent = true;

    if (formValue.storeCode) {
      setDeviceId("");
      setCompanyId("");
      setStationId("");
      setSelectedStore(formValue.storeCode);

      // Lọc lại dataTable theo storeCode được chọn
      DeviceService.getList({
        skipCount: 0,
        maxResultCount: 1000,
        storeCode: formValue.storeCode,
      }).then((response) => {
        if (!isCurrent) return;

        // Cập nhật dataTable với dữ liệu mới
        const filteredData = (response.items || []).map((item) => ({
          ...item,
          newPrice: item.newPrice ?? item.price ?? null,
        }));
        setDataTable(filteredData);
      });

      TenantSettingService.getList({ key: "DOI_GIA_TU_PECO" }).then(
        (response) => {
          if (!isCurrent) return;

          const config = parsePecoConfigForStore(
            response.items?.[0]?.value ?? "",
            formValue.storeCode
          );
          setCompanyId(config?.companyId ?? "");
          setStationId(config?.stationId ?? "");
          setDeviceId(config?.deviceId ?? "");
        }
      );
    } else {
      setDeviceId("");
      setCompanyId("");
      setStationId("");
      setSelectedStore(null);
      setDataTable([]);
    }

    return () => {
      isCurrent = false;
    };
  }, [getValueForm().storeCode]);

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      <Dialog
        header={t('catalog.pecoPriceChange')}
        visible={visible}
        style={{ width: "60vw" }}
        onHide={handleCloseDialogChangePricePECO}
      >
        {renderForm()}
      </Dialog>
      <Dialog
        header=""
        visible={openDialogConfirm}
        className="w-maxx"
        closable={false}
        onHide={() => setOpenDialogConfirm(false)}
      >
        <div className="flex flex-column gap-2">
          <p className="text-lg">
            {t('catalog.confirmPumpPriceUpdate')}
          </p>
          <div className="flex justify-content-center gap-2">
            <Button
              label={t('common.yes')}
              className="w-max"
              onClick={handleChangePricePECO}
            />
            <Button
              type="button"
              label={t('common.cancel')}
              className="w-max p-button-secondary"
              onClick={() => {
                setOpenDialogConfirm(false);
              }}
            />
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};
